import styled from 'styled-components';
import { respondTo } from 'components/styles/_respondTo';

export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 60px);
  position: relative;
  ${respondTo.desktop`
    // position: relative;
    width: calc(100vw - 274px);
    // left: 270px;
    margin-left: 270px;
    background-color: #fafafa;
    padding-bottom: 20px;
  `}
  ${respondTo.mobile`
    background-color: #ffffff;
  `}
`;
